export const pokemonRandomizerContent = {
  introduction: {
    titleKey: "pokemonRandomizer_whatIsItTitle",
    content: [
      `寶可夢隨機產生器是一種專門工具，旨在為您的寶可夢冒險注入一股全新的不可預測性和刺激感。透過洗牌各種遊戲元素——例如寶可夢遭遇、物品位置、角色能力，甚至屬性對戰——寶可夢隨機產生器工具每次都能打造出獨特的遊戲體驗。無論您是尋求新挑戰的經驗豐富的訓練家，還是想要以新穎方式探索寶可夢世界的新手，我們的隨機產生器都能提供無限的可能性。潛入一個任何事情都可能發生的寶可夢版本，您的戰略技能將以全新的方式受到考驗！`
    ],
  },
  features: {
    titleKey: "pokemonRandomizer_featuresTitle",
    content: [
      `我們的寶可夢隨機產生器以其全面的功能套件脫穎而出，旨在實現最大的樂趣和自訂性。您可以根據自己的喜好調整隨機化，選擇要洗牌的元素。從特定路線上的野生寶可夢到您收到的初始寶可夢，甚至是您找到的物品——控制權都在您手中。我們優先考慮流暢的使用者體驗，確保我們的寶可夢隨機產生器易於使用、快速，並與您對新鮮寶可夢旅程的渴望相容。進階選項允許進行微調，使其成為休閒遊戲和硬核挑戰（如Nuzlocke模式）的完美隨機產生器。`
    ],
  },
  whyUse: {
    titleKey: "pokemonRandomizer_whyUseTitle",
    content: [
      `使用寶可夢隨機產生器可以重振經典的寶可夢公式，提供令人难以置信的可重玩性。它打破了舊習慣，迫使您臨場應變，使用您可能從未考慮過的寶可夢團隊制定策略。每次遊戲都變成一個獨特的故事，充滿了意想不到的遭遇和挑戰。對於內容創作者來說，這是產生引人入勝的寶可夢內容的絕佳方式，對於任何粉絲來說，也是透過全新的視角重新發現他们最喜歡的地區的絕佳方式。如果您正在尋求偏離標準寶可夢遊戲玩法，那麼隨機產生器就是您通往無數小時新穎娛樂的大門。`
    ],
  },
  gettingStarted: {
    titleKey: "pokemonRandomizer_gettingStartedTitle",
    content: [
      `使用我們的工具開始您的第一次寶可夢隨機產生器冒險很簡單！導覽至我們的產生器，選擇您想要的隨機化篩選器——例如您遭遇的特定世代、屬性或稀有度等級。如果您正在尋找快速的團隊點子，請決定您希望產生的寶可夢數量，或者準備好進行完整的隨機化遊戲。我們直觀的介面會引導您完成選項，讓您輕鬆設定完美的隨機化寶可夢體驗。點擊「產生」，讓隨機性展開！`
    ],
  },
  faq: {
    titleKey: "pokemonRandomizer_faqTitle",
    content: [
      `**這個寶可夢隨機產生器是免費使用的嗎？** 當然！我們的工具對所有寶可夢粉絲完全免費。`, 
      `**我可以將這個隨機產生器用於特定的寶可夢遊戲嗎？** 雖然我們的工具會根據所有世代的數據產生隨機寶可夢，但它主要用於建立隨機列表或團隊。對於遊戲內的隨機產生器，您通常需要能夠修改遊戲 ROM 的軟體。我們的工具提供靈感和挑戰點子。`, 
      `**寶可夢隨機產生器的隨機性如何？** 我們利用強大的演算法來確保在您設定的參數範圍內具有高度的隨機性，提供真正不可預測且公平的體驗。`, 
      `**我可以儲存我的寶可夢隨機產生器設定嗎？** 目前，設定適用於單次會話，但我们一直在尋求根據使用者回饋新增新功能！`
    ],
  },
};

export default pokemonRandomizerContent; 